// extracted by mini-css-extract-plugin
export default {"SourceLink":"_WRQ95ptL34dOt1sMrJl"};